const IMAGE_SIZE_MOBILE = 1024;
const IMAGE_SIZE_MAX = 1776;

export { IMAGE_SIZE_MAX, IMAGE_SIZE_MOBILE };
